var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    style: {
      transform: "rotate(180deg)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14C13.5523 14 14 13.5523 14 13L14 3C14 2.44772 13.5523 2 13 2H11V0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16L3 16C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0H5L5 2H3C2.44771 2 2 2.44772 2 3L2 13C2 13.5523 2.44772 14 3 14L13 14ZM9 5.41421V11.9999H7L7 5.41421L5.20711 7.20711C4.81658 7.59763 4.18342 7.59763 3.79289 7.20711C3.40237 6.81658 3.40237 6.18342 3.79289 5.79289L7.29289 2.29289L8 1.58579L8.70711 2.29289L12.2071 5.79289C12.5976 6.18342 12.5976 6.81658 12.2071 7.20711C11.8166 7.59763 11.1834 7.59763 10.7929 7.20711L9 5.41421Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.a570235d.svg";
export { ForwardRef as ReactComponent };